import React, { Component } from "react";

class CompanyUserDelete extends Component {
  render() {
    return (
      <div>
        <h1>User Delete</h1>
      </div>
    );
  }
}

export default CompanyUserDelete;
